import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1, graphicDataColor2 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const LeftElbowPlot = forwardRef(({ recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [elbowRangeLeftMinValues, setElbowRangeLeftMinValues] = useState([]);
  const [elbowRangeLeftMaxValues, setElbowRangeLeftMaxValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let elbow_range_left_min = [];
    let elbow_range_left_max = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);
      elbow_range_left_min.push(recording.hasOwnProperty("elbow_range_left_min") ? recording.elbow_range_left_min : NaN);
      elbow_range_left_max.push(recording.hasOwnProperty("elbow_range_left_max") ? recording.elbow_range_left_max : NaN);
    });

    setPositions(positions);
    setElbowRangeLeftMinValues(elbow_range_left_min);
    setElbowRangeLeftMaxValues(elbow_range_left_max);

    return () => {
      setPositions([]);
      setElbowRangeLeftMinValues([]);
      setElbowRangeLeftMaxValues([]);
    };
  }, [recordings]);

  const leftElbowData = {
    labels: positions,
    datasets: [
      {
        label: t("minimum"),
        data: elbowRangeLeftMinValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
      {
        label: t("maximum"),
        data: elbowRangeLeftMaxValues,
        backgroundColor: [graphicDataColor2],
        borderColor: [graphicDataColor2],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("reports_leftElbowJointRange")}
        Type={Line}
        data={leftElbowData}
        axisY={t("reports_leftElbowJointRange")}
        axisX={t("sessions")}
        graphicDescription={t("graphics_leftElbowJointRangeDescription_ClinicAndHome")}
      />
    </GraphicContainer>
  );
});

export default LeftElbowPlot;
